module.exports = __webpack_public_path__ + "img/D201612_2.93da07c3.jpg";